export default {
    chatColor: 'Chat Colour',
    safeBrowseDesc: 'Prompt for approval prior to loading an unrecognised website.',
    theaterMode: 'Theatre mode'
};
